import { Col } from 'antd';
import { PermissionsEnum } from 'gql/types';
import { FormItem } from 'modules/common/components';
import { DonorSelect } from 'modules/donor/components';
import { useCurrentUser } from 'modules/user/hooks/useCurrentUser';
import { ComponentProps, FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

import { CreateAppointmentValidationSchema } from '../../CreateAppointmentsModal/schema';
import { AppointmentFormField } from '../fields';

const FIELD_NAME = AppointmentFormField.DonorId;

type PropTypes = ComponentProps<typeof FormItem> & {
  showClearButtonByDefault?: boolean;
};

const TitleSelect: FC<PropTypes> = ({
  showClearButtonByDefault,
  ...restFormItemProps
}) => {
  const { t } = useTranslation('appointments.CreateAppointmentsFormFields');
  const { control, formState, setValue, resetField } =
    useFormContext<CreateAppointmentValidationSchema>();
  const currentUser = useCurrentUser();
  const errorMessage =
    formState.errors.donorId?.message || formState.errors.donorStatus?.message;
  const canAddDonorToAppointment = currentUser.isCan(
    PermissionsEnum.AddDonorToAppointment
  );

  return (
    <Col span={24}>
      <FormItem
        colon
        className={styles.formItem}
        label={t('donorName')}
        extra={errorMessage}
        validateStatus={errorMessage && 'error'}
        {...restFormItemProps}
      >
        <DonorSelect
          allowClear
          showClearButtonByDefault={showClearButtonByDefault}
          onSelect={({ status }) =>
            setValue('donorStatus', status, { shouldValidate: true })
          }
          onClear={() => resetField(FIELD_NAME)}
          controlled={{ control, name: FIELD_NAME }}
          disabled={!canAddDonorToAppointment}
        />
      </FormItem>
    </Col>
  );
};

export default TitleSelect;
